'use client';

import React from 'react';

import {usePathname} from 'next/navigation';

import {
    CONTEXT_TYPES,
    ResourceContextMenuProvider,
    useResourceContextMenu,
} from '@udemy-v2/react-resource-context-menu';

import {TrackedCourse} from '../../context/clp-course-provider.react-component';

interface CLPContextMenuInnerProps {
    course: TrackedCourse;
}

const CLPContextMenu = ({course}: CLPContextMenuInnerProps) => {
    const pathname = usePathname();
    const {getCourseCardContextMenu} = useResourceContextMenu();
    return getCourseCardContextMenu(
        {
            id: parseInt(course.id),
            title: course.title,
            url: pathname,
            // CLP only ever renders a viewable (published) course, so this is always true here.
            isPublished: true,
            // Left empty; the "add to custom category" modal fetches the course's current
            // categories itself the first time it's opened.
            customCategoryIds: [],
        },
        {context: CONTEXT_TYPES.CLP},
    ) as React.ReactElement | null;
};

interface CLPResourceContextMenuProps {
    course: TrackedCourse;
}

/**
 * Resource context menu for the Course Landing Page, only rendered for organization users.
 * Renders two independent entry points: a "Share" menu (Assign / Recommend / Share to MS
 * Teams) and, for Enterprise-tier orgs, a second "more actions" menu (custom category /
 * learning path / course activity). Both entry points and their org-role/plan gating live
 * inside `@udemy-v2/react-resource-context-menu`.
 */
export const CLPResourceContextMenu = ({course}: CLPResourceContextMenuProps) => {
    return (
        <ResourceContextMenuProvider>
            <CLPContextMenu course={course} />
        </ResourceContextMenuProvider>
    );
};
